import { useState } from "react";
import type { FaqItem } from "@/mocks/faqs";

interface FaqListProps {
  items: FaqItem[];
}

export default function FaqList({ items }: FaqListProps) {
  const [openId, setOpenId] = useState<string | null>(items[0]?.id ?? null);

  return (
    <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <div key={item.id}>
            <h4 className="m-0">
              <button
                type="button"
                aria-expanded={open}
                onClick={() => setOpenId(open ? null : item.id)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                  {item.question}
                </span>
                <span
                  className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                    open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                </span>
              </button>
            </h4>
            {open && (
              <div className="px-5 pb-5 -mt-1">
                <p className="text-sm leading-7 text-foreground-600">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}